import IconButton from "@/components/atoms/IconButton";
import { ITableHeaderComponentProps } from "@/interfaces/Table";
import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ElementRef, FC, useRef } from "react";
import { Button, Col, FormControl, InputGroup, Row } from "react-bootstrap";
import StoreMontageMeetingStatusModal from "../modals/montage/StoreMontageMeetingStatusModal";

/**
 * L'en-tête porte la modale de création : le composant reçoit uniquement
 * `onQueryChange`, il n'a aucun moyen de remonter un événement à la page.
 * L'édition est gérée par une seconde instance, côté page.
 */
const AllMontageMeetingStatusesHeader: FC<ITableHeaderComponentProps> = ({
  onQueryChange,
}) => {
  const StoreModalRef =
    useRef<ElementRef<typeof StoreMontageMeetingStatusModal>>(null);

  return (
    <div className="d-lg-flex justify-content-between">
      <StoreMontageMeetingStatusModal
        title="Création d'un statut de rendez-vous montage"
        ref={StoreModalRef}
      />
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">Statuts de rendez-vous montage</h6>
        </Col>
        <Col xs="auto">
          <InputGroup className="position-relative input-search-width">
            <FormControl
              size="sm"
              id="search"
              type="search"
              className="shadow-none"
              placeholder="Rechercher"
              onChange={(e) => onQueryChange(e.target.value)}
            />
            <Button
              size="sm"
              variant="outline-secondary"
              className="border-300 hover-border-secondary"
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <IconButton
          variant="nolina-default"
          size="sm"
          icon={faPlus}
          transform="shrink-3"
          iconAlign="middle"
          onClick={() => StoreModalRef.current?.showOrHiddenModal()}
          className="mx-2"
        >
          <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
            Nouveau
          </span>
        </IconButton>
      </div>
    </div>
  );
};

export default AllMontageMeetingStatusesHeader;
